<template>
  <div class="body">
    <div class="header">
      <div>
        <p>{{ $t("电柜状态") }}：</p>
        <p>
                 <span v-if="dg_status!== null"> <Tag
      :color="dg_status == 2 ? 'success' : dg_status == 3 ? 'error' : 'default'"
      mini
      style="margin-right: 5px"
    >
      {{ dg_status == 2 ? $t("通讯正常") : dg_status == 3 ? $t("通讯异常") : $t("未连接") }}
    </Tag></span>

    <span v-else>--</span>
        </p>
      </div>
      <div>
        <p>{{ $t("网络状态") }}：</p>
        <p><span v-if="wl_status !== null && wl_status !== ''"> <Tag
                          :color="wl_status == 1 ? 'success' : 'error'"
                          mini
                          style="margin-right: 5px"
                        >
                          {{ wl_status == 1 ? $t("在线") : $t("离线") }}
                        </Tag></span>
                       <span v-else>--</span></p>
      </div>

    </div>
    <div>
      <Form ref="formItem" :model="formItem" inline class="form-inline">
     <div style="display: flex;">
         <FormItem label="IP：" class="form-item-inline">
          <Input v-model="formItem.ip"></Input>
        </FormItem>
        <FormItem label="端口：" class="form-item-inline">
          <Input v-model="formItem.port"></Input>
        </FormItem>
        <FormItem>
           <Button type="primary" style="width: 100px;" @click="saveData('saveDk')">{{ $t("保存端口") }}</Button>
        </FormItem>
     </div>
      <div style="display: flex;margin-top: 16px;">
          <FormItem label="电柜厂家：" class="form-item-inline">
          <Select v-model="formItem.select" style="width: 200px;">
               <Option v-for="supplier in filteredSuppliers" :key="supplier.value" :value="supplier.value">
            {{ supplier.label }}
        </Option>
          </Select>
        </FormItem>
          <FormItem>
           <Button type="primary" style="width: 100px;" @click="saveData('saveCj')">{{ $t("保存厂家") }}</Button>
        </FormItem>
      </div>
      </Form>
    </div>
    <div class="btn">
        <P><Button type="primary" @click="handleSubmit()">{{ $t("获取通讯数据") }}</Button></P>
      <p><Button type="primary" style="width: 100px;" @click="restart('4g')">{{ $t("重启4g") }}</Button></p>
      <p><Button type="primary" style="width: 100px;" @click="restart('bms')">{{ $t("重启BMS") }}</Button></p>
      <p><Button type="primary" style="width: 100px;" @click="restart('hf')">{{ $t("恢复") }}</Button></p>

  <p><Button type="primary" style="width: 100px;" @click="getState">{{ $t("更新数据") }}</Button></p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { dldpget, dldpset, get_4g_data_dg, get_device4g } from "@/api/chuku";
export default {
  name: "deviceinfo",
  data() {
    return {
      filteredSuppliers: [],
      dataRefreshInterval: null,
      did: this.$route.query.did,
      formItem: {
        ip: "",
        port: null,
        select: null
      },
      dg_status: null,
      wl_status: null,
      suppliers: [
        { value: 1, label: this.$t("永泰") },
        { value: 2, label: this.$t("盾创") },
        { value: 3, label: this.$t("比特安") },
        { value: 4, label: this.$t("贝塞尔") },
        { value: 5, label: this.$t("易鑫诺") },
        { value: 6, label: this.$t("博观") },
        { value: 7, label: this.$t("菲尼基") },
        { value: 8, label: this.$t("智寻") },
        { value: 9, label: this.$t("大能国科") },
        { value: 10, label: this.$t("博龙") },
        { value: 11, label: this.$t("龙磊") },
        { value: 12, label: this.$t("长江龙") }
      ]
    };
  },
  //  computed: {
  //       filteredSuppliers() {
  //           const ids = this.parseSupplierIds('AAMAAQACAAM=');
  //           return this.suppliers.filter(supplier => ids.includes(supplier.value));
  //       }
  //   },
  methods: {
    arrayToHex(arr) {
      return arr.map(byte => byte.toString(16).padStart(2, "0")).join(","); // 用空格隔开
    },
    base64ToUint8Array(base64) {
      // 解码 Base64 字符串
      const binaryString = atob(base64);

      // 创建一个新的 Uint8Array
      const byteLength = binaryString.length;
      const uint8Array = new Uint8Array(byteLength);

      // 将每个字符的 ASCII 值存储到 Uint8Array 中
      for (let i = 0; i < byteLength; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }

      return uint8Array;
    },
    handleSubmit() {
      const optionsRef = [
        {
          did: this.did,
          sdid: ["NULL"],
          dp_id: 2317,
          dp_chan: 0
        }
      ];
      this.requestDeviceeReportOnce(optionsRef).then(data => {
        try {
          let dpcmd = {
            dpcmd: {
              t: 0,
              did: this.did,
              timestamp: Date.now(),
              ans: false,
              dpv_count: 1,
              dps: data
            }
          };
          dldpset(dpcmd).then(res => {
            if (res.result == 0) {
              let dpcmd = {
                did: this.did,
                dpid: [2317],
                chan_num: 0
              };
              dldpget(dpcmd).then(res => {
                console.log("wodadadsa", res);

                const valRawData = res.body.body.items[0].dps[0].val_raw;
                if (typeof valRawData === "string") {
                  // 将数据转换为 Uint8Array
                  const dataStr = this.base64ToUint8Array(valRawData);
                  let text = this.arrayToHex([...dataStr]);
                  // 创建 Blob 对象
                  const blob = new Blob([text], {
                    type:
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  });

                  // 创建下载链接
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = "数据内容"; // 设置下载文件名

                  // 触发下载
                  document.body.appendChild(a);
                  a.click();

                  // 清理
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                } else {
                  console.error("valRawData 不是有效的 Base64 字符串");
                }
              });
            }
          });
        } catch (error) {
          console.error("请求错误:", error);
        }
      });
    },
    validateIP(ip) {
      const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return ipRegex.test(ip);
    },
    restart(val) {
      // 用户点击确认后执行以下代码
      let id = this.did;
      this.$Modal.confirm({
        title: "提示",
        content: this.$t("你确定要执行此操作吗？"),
        loading: true,
        onOk: function() {
          let _this = this;
          let dpcmd = {
            dpcmd: {
              t: 0,
              did: id,
              sdid: "",
              seq: 1,
              timestamp: parseInt(new Date().getTime() / 1000),
              ans: false,
              dpv_count: 1,
              dps: [
                {
                  dp_id: 2316,
                  dp_type: 1,
                  dp_chan: 0,
                  val_int64:
                    val === "4g" ? 1 : val === "bms" ? 2 : val === "hf" ? 3 : 0
                }
              ]
            }
          };
          dldpset(dpcmd).then(res => {
            if (res.result == 0) {
              _this.$Message.success("重启成功");
              _this.$Modal.remove();
            } else {
              _this.$Message.error("重启失败");
            }
          });
        }
      });
    },
    saveData(val) {
      if (val == "saveDk") {
        const base64Config = this.encodeServerConfig(
          this.formItem.ip,
          this.formItem.port,
          false
        );
        let dpcmd = {
          dpcmd: {
            t: 0,
            did: this.did,
            sdid: "",
            seq: 1,
            timestamp: parseInt(new Date().getTime() / 1000),
            ans: false,
            dpv_count: 1,
            dps: [
              {
                dp_id: 2315,
                dp_type: 4,
                dp_chan: 0,
                val_raw: [...base64Config]
              }
            ]
          }
        };
        dldpset(dpcmd).then(res => {
          if (res.result == 0) {
            this.$Message.success(this.$t("保存成功"));
          } else {
            this.$Message.error("保存失败");
          }
        });
      } else {
        const base64Config = this.encodeServerConfig(
          this.formItem.ip,
          this.formItem.port,
          false
        );
        let dpcmd = {
          dpcmd: {
            t: 0,
            did: this.did,
            sdid: "",
            seq: 1,
            timestamp: parseInt(new Date().getTime() / 1000),
            ans: false,
            dpv_count: 1,
            dps: [
              {
                dp_id: 2312,
                dp_type: 1,
                dp_chan: 0,
                val_int64: this.formItem.select
              }
            ]
          }
        };
        dldpset(dpcmd).then(res => {
          if (res.result == 0) {
            this.$Message.success(this.$t("保存成功"));
          } else {
            this.$Message.error("保存失败");
          }
        });
      }
    },
    buildDpidQuery(dpids) {
      const count = dpids.length;
      // 计算缓冲区大小：1字节（count） + 每个dpid 4字节
      const buffer = new ArrayBuffer(1 + count * 4);
      const view = new DataView(buffer);

      // 写入count
      view.setUint8(0, count);

      // 写入每个dpid
      for (let i = 0; i < count; i++) {
        // 每个dpid占用4个字节，偏移位置为 1 + i * 4
        view.setUint32(1 + i * 4, dpids[i], false); // false表示大端字节序
      }

      return buffer;
    },
    //端口转byte
    encodeServerConfig(domain, port, littleEndian = false) {
      // 1. 将域名转换为UTF-8字节数组
      const encoder = new TextEncoder();
      const domainBytes = encoder.encode(domain);
      const domainLength = domainBytes.length;

      // 2. 创建总Uint8Array (4字节端口 + 2字节长度 + 域名字节)
      const totalBytes = 4 + 2 + domainLength;
      const uint8Array = new Uint8Array(totalBytes);

      // 3. 使用DataView写入数据（按照字段顺序）
      const dataView = new DataView(uint8Array.buffer);

      // 第一个字段：port (uint32, 4字节)
      dataView.setUint32(0, port, littleEndian);

      // 第二个字段：ip_addr_len (uint16, 2字节)
      dataView.setUint16(4, domainLength, littleEndian);

      // 第三个字段：ip_addr (uint8数组，从偏移量6开始)
      for (let i = 0; i < domainLength; i++) {
        uint8Array[6 + i] = domainBytes[i];
      }

      return uint8Array;
    },
    //byte转换端口
    parseServerConfig(base64Str, littleEndian = false) {
      // 1. Base64解码
      const binaryStr = atob(base64Str);
      const bytes = new Uint8Array(binaryStr.length);

      for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }

      const dataView = new DataView(bytes.buffer);
      let offset = 0;

      // 2. 解析port (uint32, 4字节)
      const port = dataView.getUint32(offset, littleEndian);
      offset += 4;

      // 3. 解析ip_addr_len (uint16, 2字节)
      const ipAddrLen = dataView.getUint16(offset, littleEndian);
      offset += 2;

      // 4. 解析ip_addr (长度为ipAddrLen的字符串)
      let ipAddr = "";
      for (let i = 0; i < ipAddrLen; i++) {
        ipAddr += String.fromCharCode(bytes[offset + i]);
      }

      return {
        port,
        ipAddrLen,
        ipAddr
      };
    },
    buildQueryBuffer(options) {
      const {
        sdid,
        dp_id,
        dp_chan,
        lz4SrcLength = 0,
        littleEndian = false
      } = options;

      const dpChansArr = Array.isArray(dp_chan) ? [...dp_chan] : [dp_chan];
      const dpIdsArr = Array.isArray(dp_id) ? [...dp_id] : [dp_id];

      console.log(
        "dps配置项=====>",
        JSON.stringify({ sdid, chans: dpChansArr, dpids: dpIdsArr })
      );

      const encoder = new TextEncoder();
      const queryBytesList = [];

      // 为每个dp_id创建一个查询条件
      for (let i = 0; i < dpIdsArr.length; i++) {
        const queryObj = {
          sdid: sdid[0] || "", // 取第一个sdid
          chans: [dpChansArr[i] || dpChansArr[0] || 0], // 使用对应的dp_chan
          dpids: [dpIdsArr[i]]
        };

        queryBytesList.push(encoder.encode(JSON.stringify(queryObj)));
      }

      const totalLen =
        2 + 1 + queryBytesList.reduce((sum, b) => sum + 2 + b.length, 0);

      const buffer = new ArrayBuffer(totalLen);
      const dv = new DataView(buffer);
      let offset = 0;

      dv.setUint16(offset, lz4SrcLength, littleEndian);
      offset += 2;

      dv.setUint8(offset, queryBytesList.length);
      offset += 1;

      for (const bytes of queryBytesList) {
        dv.setUint16(offset, bytes.length, littleEndian);
        offset += 2;

        new Uint8Array(buffer, offset, bytes.length).set(bytes);
        offset += bytes.length;
      }

      return new Uint8Array(buffer);
    },

    async requestDeviceeReportOnce(options) {
      if (!Array.isArray(options) || options.length === 0) return;

      // 将多个查询条件合并成一个
      const mergedOption = {
        did: options[0].did,
        sdid: options[0].sdid, // 使用第一个的sdid
        dp_id: options.map(item => item.dp_id), // 收集所有的dp_id
        dp_chan: options.map(item => item.dp_chan), // 收集所有的dp_chan
        lz4SrcLength: options[0].lz4SrcLength || 0,
        littleEndian: options[0].littleEndian || false
      };

      const unit8Data = this.buildQueryBuffer(mergedOption);

      return [
        {
          dp_id: 3556,
          dp_chan: 0,
          dp_type: 4,
          val_raw: [...unit8Data]
        }
      ];
    },
    parseSupplierIds(base64Str) {
      const binaryString = atob(base64Str);
      const bytes = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const count = (bytes[0] << 8) | bytes[1];
      const result = [];

      for (let i = 0; i < count; i++) {
        const offset = 2 + i * 2;
        const id = (bytes[offset] << 8) | bytes[offset + 1];
        result.push(id);
      }

      return result; // 返回剩下的 id 数组
    },
    //获取状态
    getState() {
      this.updateData();
    },
    updateData() {
      this.did = this.$route.query.did;
      const optionsRef = [
        {
          did: this.did,
          sdid: ["NULL"],
          dp_id: 2311,
          dp_chan: 0
        },
        {
          did: this.did,
          sdid: ["NULL"],
          dp_id: 2312,
          dp_chan: 0
        },
        {
          did: this.did,
          sdid: ["NULL"],
          dp_id: 2315,
          dp_chan: 0
        },
        {
          did: this.did,
          sdid: ["NULL"],
          dp_id: 2313,
          dp_chan: 0
        },
        {
          did: this.did,
          sdid: ["NULL"],
          dp_id: 2314,
          dp_chan: 0
        }
      ];
      this.requestDeviceeReportOnce(optionsRef)
        .then(data => {
          try {
            let dpcmd = {
              dpcmd: {
                t: 0,
                did: this.did,
                timestamp: Date.now(),
                ans: false,
                dpv_count: 1,
                dps: data
              }
            };

            dldpset(dpcmd).then(res => {
              if (res.result == 0) {
                let dpcmd = {
                  did: this.did,
                  dpid: [2311, 2312, 2315],
                  chan_num: 0
                };
                dldpget(dpcmd).then(response => {
                  //端口域名
                  const result = response.body.body.items.find(
                    item => item.dps && item.dps[0].dp_id === 2315
                  );
                  let ipData = this.parseServerConfig(result.dps[0].val_raw);
                  this.formItem.ip = ipData.ipAddr;
                  this.formItem.port = ipData.port;
                  //选中厂家
                  const resultList = response.body.body.items.find(
                    item => item.dps && item.dps[0].dp_id === 2312
                  );
                  this.formItem.select = resultList.dps[0].val_int64;
                  //对应厂家
                  const resultCj = response.body.body.items.find(
                    item => item.dps && item.dps[0].dp_id === 2311
                  );
                  const ids = this.parseSupplierIds(resultCj.dps[0].val_raw);
                  this.filteredSuppliers = this.suppliers.filter(supplier =>
                    ids.includes(supplier.value)
                  );
                });
                get_device4g({ did: this.did }).then(res => {
                  const channel = res.body.chans[0];

                  setTimeout(() => {
                    get_4g_data_dg({
                      did: this.did,
                      chan: channel,
                      web_time: 0
                    }).then(response => {
                      this.dg_status = response.body.dg_status;
                      this.wl_status = response.body.wl_status;
                    });
                  }, 2000);
                });
              }
            });
          } catch (error) {
            console.error("请求错误:", error);
          }
        })
        .catch(error => {
          console.error("请求失败:", error);
        });
    }
  },
  mounted() {
    this.updateData();
    console.log("5155", this.$route, this.$route.query.did);
  },
  beforeDestroy() {
    // 在组件销毁前清除定时器
    // console.log("销毁了");
    // clearInterval(this.dataRefreshInterval);
  }
};
</script>

<style scoped>
.body {
  padding: 16px;
  margin: 16px;
  background: white;
  height: 80vh;
}
.header {
  display: flex;
}
.header div {
  display: flex;
  align-items: center;
  margin-right: 150px;
}
.form-inline {
  /* display: flex;
  align-items: center;  */
  margin-top: 30px;
}
.form-item-inline {
  display: flex;
  align-items: center;
  margin-right: 20px; /* 控制表单项间距 */
}
.form-item-inline .el-form-item__label {
  margin-right: 10px; /* 标签与输入框之间的间距 */
}
.btn {
  display: flex;
  margin-top: 30px;
}
.btn p {
  margin-right: 50px;
}
</style>
